import { useEffect } from 'react';

import { NotificationSubscriptionScope } from './NotificationContract';
import { useNotifications } from './NotificationContext';

export default function useNotificationSubscription(scope: NotificationSubscriptionScope, id: string | null | undefined) {
	const { subscribe } = useNotifications();

	useEffect(() => {
		if (!id) {
			return;
		}

		return subscribe(scope, id);
	}, [id, scope, subscribe]);
}
